import React, { useEffect, useRef } from "react";
import {
  Divider,
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { html2json, json2html } from "html2json";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { Card, CardContent, CardActions } from "../../components/Card";
import { useAlert } from "../../components/Alert";
import Button from "../../components/Button";
import DraftWysiwyg from "./DraftWysiwyg";
import LoadingModal from "../../components/LoadingModal";

const GET_EXCLUSIVEPROPERTYTEMPLATES = gql`
  query exclusivePropertyTemplates($id: Int!) {
    exclusivePropertyTemplates(id: $id) {
      id
      name
      content
    }
  }
`;

const SAVE_EXCLUSIVEPROPERTYTEMPLATE = gql`
  mutation saveExclusivePropertyTemplate(
    $exclusivePropertyTemplateInput: ExclusivePropertyTemplateInput!
  ) {
    saveExclusivePropertyTemplate(
      exclusivePropertyTemplateInput: $exclusivePropertyTemplateInput
    )
  }
`;

const DELETE_EXCLUSIVEPROPERTYTEMPLATE = gql`
  mutation deleteExclusivePropertyTemplate($id: Int!) {
    deleteExclusivePropertyTemplate(id: $id)
  }
`;

export default function TemplateForm({ id }) {
  const Alert = useAlert();
  const submit = useRef(false);
  let defaultContent;
  let contentState;
  const { handleSubmit, control, setValue, getValues } = useForm({
    defaultValues: {
      template: EditorState.createEmpty(),
      name: "",
      currentTemplate: "總店範本",
    },
  });
  const currentTemplate = useWatch({ control, name: "currentTemplate" });
  const editorState = useWatch({ control, name: "template" });
  const name = useWatch({ control, name: "name" });

  const htmlFormat = (data) => {
    const json = html2json(data);
    Array.isArray(json.child) &&
      json.child.forEach((item) => {
        if (item.tag === "div") {
          item.tag = "img";
          if (
            item.attr &&
            Array.isArray(item.child) &&
            item.child.length === 1 &&
            item.child[0].attr &&
            Array.isArray(item.child[0].attr.style)
          ) {
            const style = item.attr.style + item.child[0].attr.style.join("");
            item.attr = {
              ...item.child[0].attr,
            };
            item.attr.style = style;
          }
        }
      });

    const html = json2html(json);
    return html;
  };

  const { data, refetch, loading } = useQuery(GET_EXCLUSIVEPROPERTYTEMPLATES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      id,
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  const [
    saveExclusivePropertyTemplate,
    { loading: saveExclusivePropertyTemplateLoading },
  ] = useMutation(SAVE_EXCLUSIVEPROPERTYTEMPLATE, {
    onCompleted({ saveExclusivePropertyTemplate }) {
      if (saveExclusivePropertyTemplate) {
        Alert.notice(`儲存成功`);
        submit.current = true;
        return refetch();
      } else return Alert.notice(`儲存失敗`);
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });

  const [
    deleteExclusivePropertyTemplate,
    { loading: deleteExclusivePropertyTemplateLoading },
  ] = useMutation(DELETE_EXCLUSIVEPROPERTYTEMPLATE, {
    onCompleted({ deleteExclusivePropertyTemplate }) {
      if (deleteExclusivePropertyTemplate) {
        setValue("currentTemplate", "[空白範本標題]");
        setValue("name", "");
        setValue("template", EditorState.createEmpty());
        Alert.notice(`刪除成功`);
        return refetch();
      } else return Alert.notice(`刪除失敗`);
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });

  useEffect(() => {
    if (String(currentTemplate).includes("總店範本")) {
      defaultContent =
        htmlFormat(`<h1></h1><div style="text-align:center;"><img src="/assets/images/Template/img1.jpg" alt="" style="height: 233px;width: 1600px"/></div>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(0,0,255);background-color: rgb(255,255,0);font-size: 48px;"><strong> ★★★《法拍國父》★★★ </strong></span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="font-family: arial, helvetica, sans-serif;">●30多年來，標購自有全台各地大量資產，全部沒貸款， 展現為客戶交屋點交安全、安心保障『誠』跟『信』。</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="font-family: arial, helvetica, sans-serif;">●台灣法拍代標、點交標準建立者。建請內政部做出代標、點交規範（89）內第字第8980474號、（91）內第字0910083161號。</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(0,0,255);background-color: yellow;font-size: 48px;font-family: arial, helvetica, sans-serif;"><strong> ★★★《法拍龍頭》★★★ </strong></span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="font-size: 28px;font-family: arial, helvetica, sans-serif;">●全國第一家通過ISO9001國際標準認證。</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="font-size: 28px;font-family: arial, helvetica, sans-serif;">●全國100多家法拍屋加盟連鎖企業集團。</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(0,0,255);background-color: yellow;font-size: 48px;font-family: arial, helvetica, sans-serif;"><strong> ★★★《法拍權威－教父團隊》★★★ </strong></span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="font-size: 28px;font-family: arial, helvetica, sans-serif;">處理過無數次點交變不點交、</span><span style="font-size: 28px;">不點交、共有物及法拍各項複雜物件...等等。</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="font-size: 28px;">全台各地成交無數客戶，</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="font-size: 28px;">包括律師、醫師、會計師、警察、法院司法人員、營造廠、建設公司、上市櫃公司...等，各大大小小公司與上班族。</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(0,0,255);background-color: yellow;font-family: arial, helvetica, sans-serif;"><strong> ★★★《媒體訪問》★★★ </strong></span>&nbsp;&nbsp;</h1>
        <div style="text-align:center;"><img src="/assets/images/Template/img2.jpg" alt="" style="height: 560px;width: 1200px"/></div>   
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(0,0,255);background-color: yellow;font-family: arial, helvetica, sans-serif;"><strong> ★★★《專業講座》★★★ </strong></span>&nbsp;&nbsp;</h1>
        <div style="text-align:center;"><img src="/assets/images/Template/img3.jpg" alt="" style="height: 277px;width: 1200px"/></div>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(0,0,255);background-color: yellow;font-family: arial, helvetica, sans-serif;"><strong> ★★★《得獎紀錄》★★★ </strong></span>&nbsp;&nbsp;</h1>
        <div style="text-align:center;"><img src="/assets/images/Template/img4.jpg" alt="" style="height: 691px;width: 1200px"/></div>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <div style="text-align:center;"><img src="/assets/images/Template/img5.jpg" alt="" style="height: 441px;width: 1000px"/></div>
        <h1 style="text-align:center;"><span style="color: rgb(255,160,122);font-size: 36px;">規模最大</span><span style="font-size: 36px;">｜</span><span style="color: rgb(255,215,0);font-size: 36px;">歷史最久</span><span style="font-size: 36px;">｜</span><span style="color: rgb(0,128,128);font-size: 36px;">交屋履約保證</span><span style="font-size: 36px;">｜</span><span style="color: rgb(51,102,255);font-size: 36px;">交屋風險承擔</span><span style="font-size: 36px;">｜</span><span style="color: rgb(255,51,153);font-size: 36px;">免騷擾保固</span><span style="font-size: 36px;">｜</span><span style="color: rgb(128,0,128);font-size: 36px;">ISO國際標準</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="background-color: rgb(0,255,255);font-size: 36px;"> 沒有不能點交的房子，只有不會點交的人！</span>&nbsp;&nbsp;</h1>
        <p>&nbsp;&nbsp;</p>
        <h1 style="text-align:center;"><span style="background-color: rgb(102,255,51);font-size: 36px;"> ※  首創『無法交屋、原價買回』※ </span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(255,0,0);font-size: 28px;">【保證產權清楚，保證交易安全，保證交屋迅速】</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(255,0,0);font-size: 28px;">【專業精準評估，競價落點分析，筆錄陷阱分析】</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(255,0,0);font-size: 28px;">【投標流程解說，排除瑕疵事故，銀行代墊尾款】</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(255,0,0);font-size: 28px;">【負責全程點交，點交無須出面，交屋風險承擔】</span>&nbsp;&nbsp;</h1>
        <p>&nbsp;&nbsp;</p>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <div style="text-align:center;"><img src="/assets/images/Template/img6.jpg" alt="" style="height: 250px;width: 400px"/></div>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(68,68,68);font-family: arial, helvetica, sans-serif;">～想知道更多相關訊息，記得立即按讚追蹤～</span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;">&nbsp;</h1>
        <div style="text-align:center;"><img src="/assets/images/Template/img7.jpg" alt="" style="height: 250px;width: 400px"/></div>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;">～歡迎加入好友以便獲得第一手資訊～&nbsp;&nbsp;</h1>
        <p>&nbsp;&nbsp;</p>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;"><span style="color: rgb(255,0,0);background-color: rgb(255,255,224);font-size: 28px;">【全程點交到交屋，都不需出面。《一條龍服務》簡單、有保障。】</span>&nbsp;&nbsp;</h1>
        <p>&nbsp;&nbsp;</p>
        <h1 style="text-align:center;">&nbsp;</h1>
        <div style="text-align:center;"><img src="http://www.5137.com.tw/mail/ckeditor/plugins/smiley/images/lightbulb.gif" alt="enlightened" style="height: ;width: "/></div> 
        <h1 style="text-align:center;"><span style="color: rgb(0,0,255);background-color: rgb(255,215,0);font-size: 36px;"><strong> 請洽詢本專案經理人 </strong></span>&nbsp;&nbsp;</h1>
        <h1 style="text-align:center;">&nbsp;&nbsp;</h1>
        <p>&nbsp;&nbsp;</p>
        <h1 style="text-align:center;">&nbsp;</h1>
        <div style="text-align:center;"><img src="/assets/images/Template/img8.jpg" alt="" style="height: 522px;width: 500px"/></div>
        <h1 style="text-align:center;"><span style="color: rgb(0,0,255);background-color: rgb(255,215,0);font-size: 72px;"><strong> 富屋法拍屋企業集團 </strong></span>&nbsp;&nbsp;</h1>
        <p style="text-align:center;">&nbsp;</p> 
    `);
    } else if (String(currentTemplate).includes("空白範本標題")) {
      defaultContent = htmlFormat(`<p></p>`);
    } else {
      defaultContent = htmlFormat(
        `${data?.exclusivePropertyTemplates
          .find((item) => item.id === currentTemplate)
          .content.replace(
            /<div style="text-align:center;"><img/g,
            '<div style="text-align:none;"><img'
          )}`
      );
    }
    if (
      !String(currentTemplate).includes("空白範本標題") &&
      !String(currentTemplate).includes("總店範本")
    ) {
      setValue(
        "name",
        data?.exclusivePropertyTemplates.find(
          (item) => item.id === currentTemplate
        ).name
      );
    } else {
      setValue("name", "");
    }

    const contentBlock = htmlToDraft(defaultContent, (nodeName, node) => {
      if (nodeName === "img" && node instanceof HTMLImageElement) {
        const entityConfig = {};
        entityConfig.src = node.getAttribute
          ? node.getAttribute("src") || node.src
          : node.src;
        entityConfig.alt = node.alt;
        entityConfig.height = node.style.height;
        entityConfig.width = node.style.width;
        if (node.style.float) {
          entityConfig.alignment = node.style.float;
        } else {
          if (node.style.textAlign) {
            entityConfig.alignment = node.style.textAlign;
          }
        }

        return {
          type: "IMAGE",
          mutability: "MUTABLE",
          data: entityConfig,
        };
      }
    });

    contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks,
      contentBlock.entityMap
    );
    setValue("template", EditorState.createWithContent(contentState));
  }, [currentTemplate]);

  function _save(inputData) {
    const exclusivePropertyTemplateInput = {
      name: inputData.name,
      content: draftToHtml(
        convertToRaw(inputData.template.getCurrentContent())
      ).replace(
        /<div style="text-align:none;"><img/g,
        '<div style="text-align:center;"><img'
      ),
      franchiseStoreId: id,
    };

    if (
      data?.exclusivePropertyTemplates.find(
        (item) => item.name === inputData.name
      )
    )
      return Alert.notice("此範本名稱已存在，請更換名稱！");

    saveExclusivePropertyTemplate({
      variables: { exclusivePropertyTemplateInput },
    });
  }

  function _edit(inputData) {
    const exclusivePropertyTemplateInput = {
      id: currentTemplate,
      name: inputData.name,
      content: draftToHtml(
        convertToRaw(inputData.template.getCurrentContent())
      ).replace(
        /<div style="text-align:none;"><img/g,
        '<div style="text-align:center;"><img'
      ),
      franchiseStoreId: id,
    };

    saveExclusivePropertyTemplate({
      variables: { exclusivePropertyTemplateInput },
    });
  }

  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    if (data) {
      return (
        <Card>
          <LoadingModal
            loading={
              saveExclusivePropertyTemplateLoading ||
              deleteExclusivePropertyTemplateLoading
            }
          />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item sm={2}>
                <Typography color="primary">選擇範本</Typography>
                <Controller
                  name="currentTemplate"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <Select
                      variant="outlined"
                      fullWidth
                      {...field}
                      style={{
                        maxHeight: "40px",
                        overflow: "hidden",
                      }}
                    >
                      <MenuItem value={"總店範本"}>{"總店範本"}</MenuItem>
                      <MenuItem value={"[空白範本標題]"}>
                        {"[空白範本標題]"}
                      </MenuItem>
                      {data.exclusivePropertyTemplates.map((item) => (
                        <MenuItem value={item.id}>{item.name}</MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </Grid>
              <Grid item sm={3}>
                <Typography color="primary">範本名稱</Typography>
                <Grid item>
                  <Controller
                    name="name"
                    control={control}
                    rules={{
                      required: "請填入範本名稱",
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        error={error}
                        helperText={error && error.message}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Grid item xs={12} sm={12}>
              <Controller
                name="template"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <DraftWysiwyg
                    editorState={editorState}
                    onChange={field.onChange}
                  />
                )}
              />
            </Grid>
          </CardContent>
          <Divider />
          <CardActions>
            <Grid container spacing={1} justify="center">
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  onPress={handleSubmit(_save)}
                >
                  儲存為新範本
                </Button>
              </Grid>
              {!String(currentTemplate).includes("總店範本") &&
                !String(currentTemplate).includes("空白範本標題") && (
                  <Grid item>
                    <Button
                      color="primary"
                      variant="contained"
                      onPress={handleSubmit(_edit)}
                    >
                      修改此範本
                    </Button>
                  </Grid>
                )}
              {!String(currentTemplate).includes("總店範本") &&
                !String(currentTemplate).includes("空白範本標題") && (
                  <Grid item>
                    <Button
                      color="primary"
                      variant="contained"
                      onPress={() => {
                        Alert.alert("通知", "確定要刪除？", [
                          {
                            text: "確定",
                            onPress: () => {
                              deleteExclusivePropertyTemplate({
                                variables: { id: currentTemplate },
                              });
                            },
                            type: "ok",
                          },
                          {
                            text: "取消",
                            type: "cancel",
                          },
                        ]);
                      }}
                    >
                      刪除此範本
                    </Button>
                  </Grid>
                )}
            </Grid>
          </CardActions>
        </Card>
      );
    } else {
      return null;
    }
  }
}
